<template>
  <div class="qnr-section-nav">
    <!-- This link is for dev purposes only -->
    <!-- <div class='is-size-7 mb-5'>
        <router-link
          :to='otherURL'>
          Go to {{ isResults ? 'Questions' : 'Results' }}
        </router-link>
      </div> -->

    <div v-if="!isResults">
      <router-link
        :to="{ name: 'institutional-qnr-intro' }"
      >
        <i class="fa fa-check has-text-success" />
        <span class="text-gray">Basic Info</span>
      </router-link>
    </div>

    <div
      v-for="(section, i) in sections"
      :key="section.name"
    >
      <router-link
        :to="getURL(section, i)"
      >
        <i
          v-if="!isResults"
          class="fa fa-check has-text-success"
          :class="{ 'is-invisible': i > n - 2 }"
        />
        <span
          :class="[i === n - 1 ? 'bold' : 'text-gray']"
        >
          {{ section.name }}
        </span>
      </router-link>
    </div>

    <div v-if="isResults">
      <router-link
        :to="{ name: 'institutional-qnr-results-ips', query: { group: clientGroupID }}"
      >
        <span
          :class="[$route.name === 'institutional-qnr-results-ips' ? 'bold' : 'text-gray']"
        >
          Sample IPS</span>
      </router-link>
    </div>
  </div>
</template>


<script>
export default {
  name: 'QnrSectionNav',
  components: { /* Subcomponents */ },
  props: ['sections', 'n', 'clientGroupID'],
  data() {
    return {
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    parent() {
      return this.$parent.$options.name;
    },
    isResults() {
      return this.parent.includes('results');
    },
    base() {
      return this.getBase(this.isResults);
    },
    otherURL() {
      const name = this.getBase(!this.isResults);
      const section = this.n ? this.n : this.sections.length;
      return { name, params: { section } };
    },
  },
  watch: { /*
      Watches an existing property
      Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    getBase(results=false) {
      const insert = results ? 'results-' : '';
      return `institutional-qnr-${insert}section`;
    },
    getURL(section, i) {
      const params = { section: i + 1 };
      const url = { name: this.base, params };

      const group = this.clientGroupID;
      if (group) url.query = { group };
      return url;
    },
  },
};
</script>


<style scoped>

</style>
